// src/admin/components/AdminHeader.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi';
import { FiLogOut } from 'react-icons/fi';

const AdminHeader = ({ setSidebarOpen }) => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('adminToken');
        navigate('/admin/login');
    };

    return (
        <header className="flex items-center justify-between p-4 bg-white border-b shadow-sm">
            {/* Hamburger Menu for mobile */}
            <button onClick={() => setSidebarOpen(true)} className="text-gray-600 md:hidden">
                <FiMenu size={24} />
            </button>
            
            <div className="text-lg font-semibold text-gray-800 hidden md:block">
                Admin Dashboard
            </div>
            
            {/* Logout Button */}
            <button 
                onClick={handleLogout} 
                className="flex items-center px-4 py-2 text-sm font-medium text-white bg-orange-500 rounded-lg hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-all duration-200"
            >
                <FiLogOut className="mr-2" />
                Logout
            </button>
        </header>
    );
};

export default AdminHeader;